import { useTranslation } from 'react-i18next';

export default function ServicesSection() {
  const { t } = useTranslation('common');

  const services = [
    {
      icon: 'ri-shopping-cart-line',
      color: '#14B8A6',
    },
    {
      icon: 'ri-plant-line',
      color: '#14B8A6',
    },
    {
      icon: 'ri-store-2-line',
      color: '#14B8A6',
    },
    {
      icon: 'ri-building-line',
      color: '#14B8A6',
    },
    {
      icon: 'ri-truck-line',
      color: '#14B8A6',
    },
    {
      icon: 'ri-team-line',
      color: '#14B8A6',
    },
  ];

  return (
    <section id="services" className="py-24 bg-[#1a2332]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <i className="ri-service-line text-[#14B8A6] text-base"></i>
            <span className="text-[#14B8A6] text-sm font-medium">{t('services.badge')}</span>
          </div>
          <h2 className="text-white text-4xl font-bold mb-4">{t('services.title')}</h2>
          <p className="text-gray-400 text-base max-w-2xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-[#1f2937] rounded-3xl p-8 hover:transform hover:scale-105 transition-all duration-300 cursor-pointer group"
            >
              <div
                className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform"
                style={{ backgroundColor: `${service.color}20` }}
              >
                <i
                  className={`${service.icon} text-2xl`}
                  style={{ color: service.color }}
                ></i>
              </div>

              <h3 className="text-white text-xl font-bold mb-3">{t(`services.items.${index}.title`)}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{t(`services.items.${index}.description`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
